import Pusher from "pusher-js";
import Env from "@/env";

export default (vm) => {
  const user = vm.$session.getUserInfo(),
    pusherOptions = Env.pusherOptions(),
    pusher = new Pusher(pusherOptions.key, pusherOptions.options);
  pusher.connection.bind("error", function (err) {
    // eslint-disable-next-line no-console
    console.log(err);
  });
  if (user && user.role !== "RETAILER") {
    pusher.subscribe(`users_${user.id}`).bind("product-save", (payload) => {
      if (vm.$route.name === "dashboardDraftEdit") {
        const { brandId, brandName } = vm.$route.query || {};
        let query = brandName && brandId ? vm.$route.query : undefined;
        vm.$router.push({ path: "/dashboard/for-review", query });
      } else {
        vm.$notify.$emit("product-saved", payload);
      }
    });
    pusher.subscribe(`users_${user.id}`).bind("product-image", (payload) => {
      if (vm.$route.name === "dashboardDraftEdit") {
        vm.$router.push("/dashboard/for-review");
      } else {
        vm.$notify.$emit("product-image-saved", payload);
      }
    });

    pusher.subscribe(`users_${user.id}`).bind("collection-updated", () => {
      vm.$notify.$emit("fire", {
        message: "COLLECTION SUCCESSFULLY SAVED",
        subMessage: "Updates will be visible shortly!",
        type: "success",
        fadeTime: 5000,
      });
    });
  }
  if (user) {
    if (user.brand_id) {
      pusher.subscribe(`users_${user.brand_id}`).bind("vanity-url", (payload) => {
        user.brand_vanity_url_name = payload;
        vm.$session.setUserInfo(user);
        vm.$store.commit("setUser", user);
      });
    }

    pusher
      .subscribe(`users_${user.id}`)
      .bind("bulletin-plus", (payload) => {
        vm.$store.commit("setPlusAccess", payload);
        vm.$eventBus.$emit("accessChange");
      })
      .bind("completed", () => {
        vm.$store.dispatch("getDraftCount");
        vm.$store.commit("draftUploadEnded");
      })
      .bind("import-csv-error", (payload) => {
        vm.$store.dispatch("getDraftCount");
        vm.$store.commit("draftUploadError", payload);
      });
  }

  pusher.subscribe(`users_${user.id}`).bind("balance", () => {
    vm.$utils.balanceChangeHandler(vm.$session, vm);
  });

  pusher.subscribe(`users_${user.id}`).bind("recommendation", () => {
    vm.$notify.$emit("fire", {
      message: "Our Merch Team dropped you some new recommendations!",
      redirection: "/dashboard/favorites",
      type: "success",
    });
  });
};
